module.exports = __webpack_public_path__ + "img/fob_pin_green.920ba4ad.svg";